var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"app-minibars",style:(_vm.rootStyle),attrs:{"aria-hidden":"true"}},_vm._l((_vm.bars),function(bar,i){return _c('span',{key:i,staticClass:"app-minibars__bar",class:bar.cls,style:(bar.style)})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }